<template>
  <div>
    <v-flex xs12 sm12 md12>
      <v-container fluid>
        <tabulations-list />
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import TabulationsList from "../../components/configuration/TabulationsList.vue";

export default {
  components: { TabulationsList },
};
</script>
